(function ($) {


  
  document.addEventListener("DOMContentLoaded", function () {
    const toggleButton = document.getElementById("toggle-description");
    const descriptionContent = document.getElementById("description-content");

    toggleButton.addEventListener("click", function () {
      if (descriptionContent.style.display === "none") {
        descriptionContent.style.display = "block";
        toggleButton.textContent = " Lees verder";
      } else {
        descriptionContent.style.display = "none";
        toggleButton.textContent = " Lees verder";
      }
    });
  });

  $(document).ready(function () {
    $(".toggle-button").on("click", function () {
      $("#shortext_display").toggle(); // Toggle the visibility of the details div
      // Change button text based on visibility
      //$(this).text($(this).text() === 'Show Details' ? 'Hide Details' : 'Show Details');
    });
  });

  

  //=====Latest Blog Post Slider=========//

  document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".slider");
    const leftArrow = document.querySelector(".left-arrow");
    const rightArrow = document.querySelector(".right-arrow");
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener("mousedown", (e) => {
      isDown = true;
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener("mouseleave", () => {
      isDown = false;
    });

    slider.addEventListener("mouseup", () => {
      isDown = false;
    });

    slider.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 2; //scroll-fast
      slider.scrollLeft = scrollLeft - walk;
    });

    // Arrow functionality
    rightArrow.addEventListener("click", () => {
      slider.scrollBy({ left: 500, behavior: "smooth" }); // Adjust scroll amount as needed
    });

    leftArrow.addEventListener("click", () => {
      slider.scrollBy({ left: -500, behavior: "smooth" }); // Adjust scroll amount as needed
    });
  });

  jQuery(".vowWK").css("color", "red");

  jQuery(".vowWK").attr("id", "newID");

  //---------Red color----------------//

/*
  $('label[for="ProductSelect-8878478491977-option-kleur-red"]').append(
    '<img style="width:100px" src="https://kovapaa.nl/cdn/shop/files/LappiBinnenkantBlauw_900x.jpg?v=1706609933" alt="Description of image">'
  );
*/

document.addEventListener("DOMContentLoaded", function () {
    const variantRadios = document.querySelectorAll('input[name="variant"]');
    const hiddenVariantInput = document.getElementById("selected-variant-id");

    variantRadios.forEach(radio => {
        radio.addEventListener("change", function () {
            hiddenVariantInput.value = this.value; // Update hidden input with selected variant ID
        });
    });
});

// ==========================================
// PREORDER FUNCTIONALITY
// ==========================================

document.addEventListener("DOMContentLoaded", function() {
    
    // Preorder buttons now work like regular add-to-cart buttons
    // No special handling needed - they use normal form submission
    
    // Watch for variant changes to update preorder availability
    const variantSelectors = document.querySelectorAll('input[name="id"], select[name="id"]');
    variantSelectors.forEach(selector => {
        selector.addEventListener('change', function() {
            updatePreorderDisplay(this.value);
        });
    });
    
});



/**
 * Update preorder display when variant changes
 * @param {string} variantId - Selected variant ID
 */
function updatePreorderDisplay(variantId) {
    // This would typically fetch variant data and update preorder info
    // For now, we'll just refresh the preorder container visibility
    const preorderContainer = document.querySelector('#preorder-container');
    
    if (preorderContainer && window.theme && theme.variants) {
        const variant = theme.variants.find(v => v.id == variantId);
        
        if (variant) {
            const isAvailable = variant.available && variant.inventory_quantity > 0;
            preorderContainer.style.display = isAvailable ? 'none' : 'block';
        }
    }
}




})(jQuery);
